import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Role } from '../../types';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
    providedIn: 'root',
})
export class PermissionGuard implements CanActivate {

    private checkRole(requiredRoles: Role[]): boolean {
        const userRole = this.authService.role;
        return userRole ? requiredRoles.includes(userRole) : false;
    }

    constructor(protected authService: AuthService, protected router: Router) { }

    canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if(this.checkRole(next.data.roles)) {
            return true;
        }
        else {
            this.router.navigate(['/dashboard']);
            return false;
        }
    }

}
